import { render, staticRenderFns } from "./MyBlogPage.vue?vue&type=template&id=23a78e55&scoped=true&"
import script from "./MyBlogPage.vue?vue&type=script&lang=js&"
export * from "./MyBlogPage.vue?vue&type=script&lang=js&"
import style0 from "./MyBlogPage.vue?vue&type=style&index=0&id=23a78e55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a78e55",
  null
  
)

export default component.exports